// WP-0.7 (§18.1): the sidebar/menu navigation model, derived from the route table so the
// desktop sidebar and the mobile "Menu (everything else)" sheet stay in sync.
import { NAV_GROUP_LABELS, ROUTES, type NavGroup } from './routes';

export interface NavItem {
  path: string;
  label: string;
  icon: string;
}

export interface NavSection {
  group: NavGroup;
  label: string | null; // group header (null for the top/bottom ungrouped bands)
  items: NavItem[];
}

const GROUP_ORDER: NavGroup[] = ['top', 'money', 'work', 'insight', 'plan', 'schedule', 'bottom'];

export const NAV_SECTIONS: NavSection[] = GROUP_ORDER.map((group) => ({
  group,
  label:
    group in NAV_GROUP_LABELS ? NAV_GROUP_LABELS[group as keyof typeof NAV_GROUP_LABELS] : null,
  items: ROUTES.filter((r) => r.nav?.group === group)
    .sort((a, b) => (a.nav?.order ?? 0) - (b.nav?.order ?? 0))
    .map((r) => ({ path: r.path, label: r.nav?.label ?? r.title, icon: r.nav?.icon ?? 'Circle' })),
})).filter((s) => s.items.length > 0);
